import { createGlobalStyle } from 'styled-components';
import { appColor } from '../modules/theme';

export const GlobalStyles = createGlobalStyle`
  img {
    height: auto;
    max-width: 100%;
  }

  a {
    color: ${appColor};
    text-decoration: none;

    &.disabled {
      pointer-events: none;
    }
  }

  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px silver;
    border-radius: 6px;
}

::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: black;
    border: 1px solid white;
    box-shadow: inset 0 0 4px white;
}

::-webkit-scrollbar-thumb:hover {
    box-shadow: inset 0 0 8px #00a6ff;
}
`;
